import constants from '../constants';
import { useSelector } from 'react-redux';
import { selectAllStrings } from '../features/language/languageSlice';
import React, { useState } from 'react';
import FullAccessModal from '../features/user/FullAccessModal';

const BuyAccessButton = () => {
    const strings = useSelector(selectAllStrings);
    const [showAccessModal, setShowAccessModal] = useState(false);
    
    const buyClicked = event => {
        event.preventDefault();
        setShowAccessModal(true);
    };
    
    return <React.Fragment>
    {constants.environment === 'iOS' ?
                <a onClick={buyClicked} className="btn" id="buy_card">{strings.buy_access}</a>
                : 
                <a className="btn light" id="buy_card" 
        href="https://account.pleinairclub.it/?page_id=23&c=2#panel-register" target="_blank">
        {strings.buy_card}</a>}
        {showAccessModal ? <FullAccessModal onClose={() => setShowAccessModal(false)}/> : null}
        </React.Fragment>;
};

export default BuyAccessButton;